export default function CaseStudies() {
  const cases = [
    {
      title: '飲食店様',
      category: 'レストラン',
      description: '地域密着型のレストランのWebサイトを制作。オンライン予約機能とメニュー紹介により、来店客数が30%増加しました。'
    },
    {
      title: '美容サロン様',
      category: 'ビューティー',
      description: 'スタイリッシュなデザインと予約システムの導入により、新規顧客の獲得に成功。月間予約数が2倍になりました。'
    },
    {
      title: '士業事務所様',
      category: '法律・会計',
      description: '信頼感のあるデザインと分かりやすいサービス紹介により、問い合わせ数が50%増加。SEO対策も効果的でした。'
    }
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            制作実績
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto">
            様々な業種のお客様にご利用いただいています
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {cases.map((caseStudy, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden p-6 sm:p-8"
            >
              <div className="mb-6">
                <span className="bg-teal-600 text-white px-3 sm:px-4 py-1 sm:py-1.5 rounded-full text-xs sm:text-sm font-semibold">
                  {caseStudy.category}
                </span>
              </div>

              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                {caseStudy.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                {caseStudy.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}